import logo from "../resources/alternateLogo.png";

export function ComingSoonPage() {
  return (
    <div className="App">
      <img src={logo} alt="BLAZE" height="400px" width="500px" />
      <p className="para">Opening Soon...</p>
    </div>
  );
}
